function initializeNewsSliders() {
  $(".news-slider")
    .not(".slick-initialized")
    .each(function () {
      const $slider = $(this);
      const $wrapper = $slider.parent();

      $slider.slick({
        infinite: false,
        slidesToShow: 1,
        prevArrow: $wrapper.find(".slick-prev"),
        nextArrow: $wrapper.find(".slick-next"),
        centerMode: true,
        dots: true,
        centerPadding: 0,
        focusOnChange: true,
        accessibility: true,
      });
    });
}

$(document).ready(function () {
  initializeNewsSliders();
});
